module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5acea83c866fa50bf9b824e8bdee4332.png";